const GREEN = '#8CCA3A';
const GREY = '#828287';
const RED = '#DB2F2D';

const COLOR_MAP = {
  bad: RED,
  good: GREEN,
  null: GREY
};

export default COLOR_MAP;
